// extracted by mini-css-extract-plugin
export var layoutContainer = "_e3-0";
export var layoutContainerNoRounding = "_e3-6";
export var layoutContainerOpen = "_e3-5";
export var layoutContainerResizing = "_e3-1";
export var mainContent = "_e3-2";
export var resizeDivider = "_e3-3";
export var slidePanel = "_e3-4";